module.exports = __webpack_public_path__ + "img/logo-branco.50a9199b.png";